import { createContext, useContext, useState, useEffect, useRef } from 'react';
import { UserContext } from './UserContext';
import { get_testing_hq } from '../utils/restapi';

const TestingHqContext = createContext();

export const TestingHqProvider = ({ children }) => {
  const { user, isLogin } = useContext(UserContext);
  const [testingHqs, setTestingHqs] = useState([]);
  const isLoading = useRef(false);

  // isLogin 상태 변화 감지하여 리다이렉트
  useEffect(() => {
    if (isLogin.current === false) {
      // 현재 페이지가 /가 아닌 경우에만 리다이렉트
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    } else if (isLogin.current === true && user?.person_id) {
      getTestingHq();
    }

    // eslint-disable-next-line
  }, [user]); // user 상태가 변할 때마다 체크

  const getTestingHq = () => {
    if (!isLogin || !user?.person_id) {
      setTestingHqs([]);
      return null;
    }

    isLoading.current = true;
    get_testing_hq(user.person_id)
      .then((response) => {
        //console.log('get_testing_hq response: ', response);
        setTestingHqs(response);
      })
      .catch((error) => {
        console.error('Error fetching user data:', error.message);
        alert(error.message);
        setTestingHqs([]);
        // 여기서는 리다이렉트하지 않음 (useEffect에서 처리)
      })
      .finally(() => {
        isLoading.current = false;
      });
  };

  return (
    <TestingHqContext.Provider value={{ testingHqs, setTestingHqs, isLoading }}>
      {children}
    </TestingHqContext.Provider>
  );
};

export const useTestingHq = () => useContext(TestingHqContext);
export { TestingHqContext };